export default __webpack_public_path__ + "static/media/ILUSTRACIONES_09.8ee9ad7a.png";